export enum AblyNamespace {
  EDITOR = 'editor',
  AUTH = 'auth',
}
